<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="border-radius: 5px !important; padding-left: 0px;height:auto !important;"
          toggleable="lg" type="dark" variant="primary">
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Email User Master</b-navbar-brand>

          <b-navbar-nav class="ml-auto">
            <b-nav-form
              v-if="$sessionsStorage.get('designation') == 'Admin' &&  $sessionsStorage.get('nameUser') == 'Bhavneesh' ">
              <b-button variant="outline-primary" @click="addEditCardFunc()" size="sm">Add</b-button>
              <b-button :disabled="ExcelBtnName != 'Export as Excel' ? true : false" class="ml-3"
                @click="getAllEmailUserList('Excel')" size="sm" variant="outline-info">{{ ExcelBtnName }}
                <b-spinner v-if="ExcelBtnName != 'Export as Excel'" small label="Small Spinner"></b-spinner></b-button>

            </b-nav-form>

          </b-navbar-nav>

          <!-- <b-button
            v-if="
                  $sessionsStorage.get('designation') == 'Admin' &&
                  $sessionsStorage.get('nameUser') == 'Bhavneesh'
                "
            size="sm"
            class="ml-1"
            @click="getReports('All_Module_Report')"
            variant="outline-info"
          >Export</b-button>-->
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <!-- Add Update Form Input End-->
            <b-card class="gutr" v-if="addEditCard">
              <b-row class="justify-content-left">
                <b-col md="12">
                  <h5>Email User Details</h5>
                </b-col>
                <b-col md="3">
                  <label>
                    Email NAME
                    <span class="error">*</span>
                  </label>
                  <b-form-input :formatter="capitalizeAll" id="emailuser_name" name="emailuser_name"
                    v-model="EmailUserMaster.emailuser_name" placeholder="Email Name"></b-form-input>
                  <span class="error" v-if="!EmailUserMaster.emailuser_name">
                    {{
                    errorList.emailuser_name
                    }}
                  </span>
                </b-col>

                <b-col md="3">
                  <label>
                    Emails
                    <span class="error">*</span>
                  </label>
                  <b-form-input :formatter="capitalizeAll" id="emailuser_mail" name="emailuser_mail"
                    v-model="EmailUserMaster.emailuser_mail" placeholder="Emails"></b-form-input>
                  <span class="error" v-if="!EmailUserMaster.emailuser_mail">
                    {{
                    errorList.emailuser_mail
                    }}
                  </span>
                </b-col>

                <b-col md="3">
                  <label>Status</label><br>
                  <md-switch :id="'approval'+EmailUserMaster.is_emailuser_active" name="approval" class="md-primary"
                    :value="EmailUserMaster.is_emailuser_active==1?true:false" @change="activateemailuserMaster()">
                    <h6>
                      <b-badge
                        :variant="EmailUserMaster.is_emailuser_active==1?'success':'danger'">{{EmailUserMaster.is_emailuser_active==1?"Active":"In-Active"
                        }}</b-badge>
                    </h6>
                  </md-switch>
                </b-col>
                <b-col md="12">
                  <center>
                    <b-button style="margin-bottom: 0.3rem" variant="success" @click="addEmailUserMaster" class="mt-2"
                      id="addButtonLoader">
                      {{
                      emailuserMaster.emailuser_id ? "Update" : "Save"
                      }}
                    </b-button>
                  </center>
                  <md-spinner md-indeterminate id="loader" style="display: none"></md-spinner>
                </b-col>
              </b-row>
            </b-card>
            <!-- Add Update Form Input End-->

            <div class="mt-3">
              <!-- Search Form Input Start-->
              <b-row>
                <b-col md="10" class="my-1">
                  <b-form-group>
                    <b-input-group>
                      <b-form-input :formatter="capitalizeAll" @input="debounceSearch" v-model="filter"
                        placeholder="Type to Search Email User Master" ref="search" />
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filterClear">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <h5><small v-if="isLoading == false">{{ totalRows }} Entries</small></h5>
                </b-col>
              </b-row>
              <!-- Search Form Input End-->
              <!-- Main table element -->
              <div class="table-responsive tableMain">
                <b-table show-empty stacked="md" :items="All_EmailUser_List_data" :fields="fields"
                  :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered" responsive
                  primary-key="emailuser_id" class="position-relative">
                  <template slot="emailuser_id" slot-scope="row0">
                    <span>{{row0.index + 1 + (currentPage - 1) * perPage }}</span>
                  </template>
                  <template slot="emailuser_mail" slot-scope="row1">
                    <span
                      @click="$sessionsStorage.get('designation') == 'Admin' &&  $sessionsStorage.get('nameUser') == 'Bhavneesh'? viewEdit(row1.item):''"
                      class="showMoreData">{{row1.item.emailuser_mail}}</span>
                  </template>
                  <template slot="is_emailuser_active" slot-scope="row22">
                    <div v-if="adminToggle =='Admin'" :id="'row'+row22.item.emailuser_id">
                      <md-switch :id="'approval'+row22.item.emailuser_id" name="approval" class="md-primary"
                        :value="row22.item.is_emailuser_active==1?true:false"
                        @change="activateModuleUser(row22.item, 'Active')">
                        <h6>
                          <br>
                          <b-badge
                            style="margin-left:-45px">{{row22.item.is_emailuser_active==1?'Active':'In-Active'}}</b-badge>
                        </h6>
                      </md-switch>
                    </div>
                    <div v-else :id="'row'+row22.item.emailuser_id">
                      <h6>
                        <b-badge>{{row22.item.is_emailuser_active==1?'Active':'In-Active'}}</b-badge>
                      </h6>
                    </div>
                  </template>
                  <template slot="is_emailuser_delete" slot-scope="row22">
                    <div v-if="adminToggle =='Admin'" :id="'row'+row22.item.emailuser_id">
                      <md-switch :id="'approval'+row22.item.emailuser_id" name="approval" class="md-primary"
                        :value="row22.item.is_emailuser_delete==1?true:false"
                        @change="activateModuleUser(row22.item, 'Delete')">
                        <h6>
                          <br>
                          <b-badge style="margin-left:-45px">{{row22.item.is_emailuser_delete==1?'Delete':'Not Deleted'}}</b-badge>
                        </h6>
                      </md-switch>
                    </div>
                    <div v-else :id="'row'+row22.item.emailuser_id">
                      <h6>
                        <b-badge>{{row22.item.is_emailuser_delete==1?'Deleted':'Not Delete'}}</b-badge>
                      </h6>
                    </div>
                  </template>

                  <template slot="action" slot-scope="row2">
                    <b-button variant="outline-primary" @click="editEmailUserMaster(row2.item)" id="addButtonLoader"
                      size="sm">Update</b-button>
                  </template>
                </b-table>
              </div>
              <b-row>
                <b-col md="12" class="my-1">
                  <b-pagination limit="25" :total-rows="totalRows" :per-page="perPage" v-model="currentPage"
                    class="my-0 pull-right" />
                </b-col>
              </b-row>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect, MultiSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import CommonService from "../../services/CommonService.js";
import ClientUserService from "../../services/ClientUserService.js";
import CustomLoader from "../common/customLoader.vue";
export default {
  beforeMount() {
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/email-userMaster");
      if (globalPermissionStatus("Email-User Master") != "Disabled") {
        this.$sessionsStorage.set(
          "PermissionStatus",
          globalPermissionStatus("Email-User Master")
        );
      } else {
        this.$router.push({
          path: "/dashboard"
        });
      }
      this.getAllEmailUserList('Normal');
    } else {
      this.$router.push({
        path: "/Login/"
      });
    }
  },
  data() {
    return {
      ExcelBtnName: "Export as Excel",
      addEditCard: false,
      isLoading: false,
      fields: [
        {
          key: "emailuser_id",
          label: "SN.",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "emailuser_mail",
          label: "Email Details",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "is_emailuser_active",
          label: "Status",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "is_emailuser_delete",
          label: "Is Delete",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "action",
          label: "action",
          sortable: true,
          sortDirection: "desc"
        },
      ],
      currentPage: 1,
      perPage: 10,
      adminToggle: this.$sessionsStorage.get("designation"),
      totalRows: "",
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      modalInfo: { title: "", content: "" },
      alert: {
        content: "Added Succesfully",
        ok: "ok"
      },
      EmailUserMaster: {
        emailuser_id: "",
        emailuser_name: "",
        emailuser_mail: "",
        is_emailuser_active: true,
        TypeofAdd: "Email User Add"
      },
      EmailUserMasterError: [
        "Please Enter Email Name",
        "Please Enter Email",
      ],
      errorList: {
        emailuser_name: "",
        emailuser_mail: "",
      },
      All_EmailUser_List_data: [],
      validate: true
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    }
  },
  mounted() {},

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    MultiSelect
  },

  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  methods: {
    activateemailuserMaster() {
      if (this.emailuserMaster.is_emailuser_active == 1 || this.emailuserMaster.is_emailuser_active == true) {
        this.emailuserMaster.is_emailuser_active = false;
      } else if (
        this.emailuserMaster.is_emailuser_active == 0 ||
        this.emailuserMaster.is_emailuser_active == false
      ) {
        this.emailuserMaster.is_emailuser_active = true;
      }
    },

    validateRefuelStation() {
      let validate_new = true;

      if (this.emailuserMaster.categoryType == "") {
        $("#categoryType").focus();
        this.categoryTypeError = "Select Category";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    activateModuleUser(item, type) {
      let FieldVal = '';
      let TableField = '';
      if(type == "Active"){
        FieldVal = item.is_emailuser_active == 1 ? 0 : 1;
        TableField = "is_emailuser_active";
      } else if(type == "Delete"){
        FieldVal = item.is_emailuser_delete == 1 ? 0 : 1;
        TableField = "is_emailuser_delete";
      }
      let payload = {
          tableName: "emailuser_master",
          tableId: "emailuser_id",
          tableIsActive: TableField,
          value1: FieldVal,
          tableVal: item.emailuser_id,
          isMailSend:'No',
          manual:'No',
      };
      //console.log("Payload => ", payload); return false;
      ClientUserService.getAllActive(JSON.stringify(payload))
      .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            this.getAllEmailUserList("Normal");
          }
      })
      .catch((error) => {
          console.log("Catch on getAllActive Error: ", error);
      });
    },


    validateEmailUserMaster() {
      let validate_new = true;
      Object.keys(this.errorList).map((x, index) => {
          if (
          this.EmailUserMaster[x] == "" ||
          this.EmailUserMaster[x] == undefined ||
          this.EmailUserMaster[x] == null
          ) {
              console.log("this.EmailUserMaster[x]=>",this.EmailUserMaster[x],x);
              console.log("this.EmailUserMaster[x]=>",this.EmailUserMaster);
          this.errorList[x] = this.EmailUserMasterError[index];
          validate_new = false;
          }
      });
      if (validate_new != true) {
          this.validate = false;
          return;
      } else {
          this.validate = true;
      }
    },
    addEmailUserMaster() {
      this.validateEmailUserMaster();
      this.EmailUserMaster.TypeofAdd = "Email User Add";
      if (this.validate == false) return false;
      this.isLoading = true;

      let payload = {
          itemCode: "add_Email_User_Details",
          EmailUserMaster: this.EmailUserMaster
      };
      payload = JSON.stringify(payload);
      if (this.validate != false) {
          CommonService.getAllCommonMaster(payload)
          .then(response => {
              const { data, status, statusText } = response;
              if (data.emailuser_id != "" && data.emailuser_id != undefined) {
                if (data.find == 1 || data.find == 2) {
                    this.alert.content = data.MSG;
                } else {
                    this.alert.content = data.MSG;
                }
                this.EmailUserMaster = "";
                this.getAllEmailUserList('Normal');
              } else {
                this.alert.content = data.MSG;
              }
              this.isLoading = false;
              this.$refs["addPop"].open();
          })
          .catch(error => {
              console.log("Catch on Proforma Error: ", error);
          });
      }
    },
    clearErrVal() {
      this.emailuserMaster = {
        emailuser_name: "",
        emailuser_mail: "",
        is_emailuser_active: true,
        TypeofAdd: "Email-User Master Add"
      };
    },
    getAllEmailUserList(type) {
      this.All_EmailUser_List_data = [];
      this.totalRows = 0;
      this.isLoading = true;
      if(type == "Excel"){
        this.ExcelBtnName = "Downloading Please Wait...";
      }
      let payload = {
          itemCode: "All_EmailUser_List",
          Filter: this.filter,
          type: type,
      };
      // JSON.stringify();
      // await
      CommonService.getAllCommonMaster(payload)
      .then(response => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (type == "Excel") {
              this.ExcelBtnName = "Export As Excel";
              if (data.All_EmailUser_List_data.length > 0) {
                this.All_EmailUser_List_data = data.All_EmailUser_List_data;
                this.totalRows = data.All_EmailUser_List_data.length;
              }
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              if (data.All_EmailUser_List_data.length > 0) {
                this.All_EmailUser_List_data = data.All_EmailUser_List_data;
                this.totalRows = data.All_EmailUser_List_data.length;
                console.log(" All_Module_List response=>", data);
              }
            }
          } else {
            this.All_EmailUser_List_data = [];
          }
          this.isLoading = false;
      })
      .catch(error => {
          console.log("Catch on All_Module_List Error: ", error);
      });
    },
    
    editEmailUserMaster(item) {
      console.log(item);
      this.clearErrVal();
      this.addEditCard = true;
      item.TypeofAdd = "Email-User Master Add";
      this.EmailUserMaster = item;
      this.setFocus();
    },
    addEditCardFunc() {
      this.clearErrVal();
      this.addEditCard = !this.addEditCard;
    },
    setFocus: function() {
      // Note, you need to add a ref="search" attribute to your input.
      this.$refs.search.focus();
    },
    previousSalesView() {
      window.history.go(-1);
    },
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getAllEmailUserList('Normal');
      }, 1000);
    },
    filterClear() {
      this.filter = "";
      this.getAllEmailUserList('Normal');
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    JqueryFun() {
      return $(function() {
        return $("#portLocationNew").DataTable();
      });
    },

   
  }
};
</script>

<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>


// WEBPACK FOOTER //
// emailuserMaster.vue?0e3b2aec